import React from 'react';
import * as echarts from 'echarts/core';
import { SVGRenderer } from 'echarts/renderers';
import { BarChart, LineChart, PieChart } from 'echarts/charts';
import { GridComponent, TooltipComponent } from 'echarts/components';
import ReactEchartsCore from 'echarts-for-react/lib/core';
import theme from 'shared/constants/theme.json';

const DEFAULT_CHART_OPTIONS = {
  color: [
    '#6B50B8',
    '#464FA4',
    '#3A89B0',
    '#349898',
    '#458B70',
    '#729E38',
    '#E7C80F',
    '#E0841E',
    '#CA5D20',
    '#9C3030',
    '#9F3766',
    '#953788',
  ],
  textStyle: {
    fontSize: theme['font-size-base'],
    fontFamily: theme['font-family'],
  },
};

echarts.use([
  SVGRenderer,
  BarChart,
  LineChart,
  PieChart,
  GridComponent,
  TooltipComponent,
]);

const DEFAULT_TOOLTIP_OPTIONS = {
  className: 'chart-tooltip',
  confine: true,
  extraCssText: 'white-space:normal;max-width:min(600px,calc(100vw - 32px));',
};

const Chart = ({ option, height, onEvents }) => (
  <ReactEchartsCore
    echarts={echarts}
    style={{ height }}
    option={{
      ...DEFAULT_CHART_OPTIONS,
      ...option,
      tooltip: option?.tooltip
        ? { ...DEFAULT_TOOLTIP_OPTIONS, ...option.tooltip }
        : option?.tooltip,
    }}
    opts={{ renderer: 'svg' }}
    onEvents={onEvents}
    notMerge
  />
);

export default Chart;
